module.exports = __webpack_public_path__ + "static/media/selfModal.187540b9.jpg";